<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Winter Roses</h1>
</div>
</div>
<h1 class="bttitle">
	Winter Roses</h1>
<h2 class="author">
	Anita Mills</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap137774.vue?2eb1bfc0